import {CSSProperties, FC} from 'react';


export interface IIconPdfProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconPdf: FC<IIconPdfProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="M3 15.692V9h3.142c.714 0 1.272.188 1.673.563.402.382.603.9.603 1.556 0 .665-.231 1.195-.694 1.591-.442.379-1.028.568-1.76.568H4.43v2.414H3Zm1.43-3.55h1.387c.327 0 .593-.09.798-.268.214-.191.32-.444.32-.759 0-.312-.098-.553-.294-.724-.197-.17-.465-.255-.806-.255H4.43v2.006ZM9.32 15.692V9h2.3c1.171 0 2.042.279 2.614.836.56.547.841 1.374.841 2.484 0 2.248-1.151 3.372-3.454 3.372H9.319Zm1.447-1.162h.88c.656 0 1.153-.206 1.49-.62.31-.375.464-.907.464-1.594 0-.775-.19-1.341-.572-1.7-.323-.303-.773-.454-1.348-.454h-.914v4.368ZM16.115 15.692V9H21v1.188h-3.437v1.547h3.056v1.188h-3.056v2.769h-1.448Z" />
        </svg>
    );
};
